import config from '../config';
import CorniceBrowser from './CorniceBrowser';
import Link from 'next/link';
import Logo from './Logo';
import React from 'react';
import useTranslation from 'next-translate/useTranslation';

export default function SignInUpLayout({ children }) {
  const { t } = useTranslation('common');

  return (
    <div className="flex h-screen">
      <div className="dimora-brand-panel hidden lg:flex flex-col items-center justify-between text-center text-foreground w-[34rem] px-12 py-14 border-r border-border">
        <div className="flex flex-col items-center gap-6">
          <Link href="/" aria-label="Torna alla pagina principale">
            <Logo size="lg" />
          </Link>
          <div className="text-muted-foreground max-w-xs">
            {t('Rents, tenants and properties, all in one place')}
          </div>
        </div>

        {/* Il prodotto vero al posto di un'illustrazione: il cruscotto in tema chiaro */}
        <CorniceBrowser
          src={`${config.BASE_PATH}/screens/cruscotto.png`}
          alt="Cruscotto di Dimora con affitti, occupazione e ricavi"
          indirizzo="dimora.local/cruscotto"
          className="w-full"
          eager
        />

        <div className="text-xs text-muted-foreground/80 leading-relaxed">
          <div>{t('for landlords')}</div>
          <div className="mt-1">
            {config.APP_NAME} —{' '}
            {t('by {{author}}', {
              author: 'Giuseppe Delli Paoli'
            })}
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center w-full relative bg-body">
        <div className="lg:hidden mb-8">
          <Link href="/" aria-label="Torna alla pagina principale">
            <Logo size="md" />
          </Link>
        </div>
        {children}
      </div>
    </div>
  );
}
